import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { LanguageService } from "../services/language.service";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const languageService = inject(LanguageService);
  const currentLang = languageService.currentLanguage();

  let headers = req.headers.set('Accept-Language', currentLang);

  const clonedReq = req.clone({ headers });
  return next(clonedReq);
}
